// 4px base scale (matches sk-catalog convention; the HTML's paddings are 4px-grid).
export const Spacing = {
  0:  0,
  1:  4,
  2:  8,
  3:  12,
  4:  16,
  5:  20,
  6:  24,
  8:  32,
  10: 40,
  12: 48,
  16: 64,
};
